module.exports = __webpack_public_path__ + "assets/d7afe4eb369e01eefde19cdb5c55f503.mp3";